// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"378":"BuffetPage","703":"HomePage","860":"createApp"}[chunkId] + "." + {"378":"fb17f6e1","703":"b2368fef","860":"6de33c66"}[chunkId] + ".css";
};